import styled from 'styled-components';

const AppStyle = styled.div`
	background-color: ${(p) => p.theme.color.purple};
	h1,
	h2,
	h3 {
		font-family: ${(p) => p.theme.fonts.heading};
		font-size: 2.5rem;
	}
	p,
	li,
	th,
	td,
	a,
	button,
	h4 {
		font-family: ${(p) => p.theme.fonts.body};
	}
	p {
		font-size: 1rem;
		line-height: 1.5;
		letter-spacing: 1px;
	}
	strong {
		font-weight: 700;
	}
	img {
		display: block;
		max-width: 100%;
	}
`;

export default AppStyle;
